import React from 'react';
import PropTypes from 'prop-types';
import Pagination from '../../pagination';
import AddNew from './../addNew';
import Reply from './reply';


const Replies = ({
  t,
  count,
  goToPage,
  criteria,
  replies,
  upload_name,
  submitReply,
  backgroundColor,
  markAsResolved,
}) => (
  <React.Fragment>
    <div className="cmntboxouter boxs" id="replies">
      <div className="boxs cmntbox">
        <div className={replies.length ? 'replyticket box' : 'boxs'}>
          {replies.map(item => (
            <div key={item.id}>
              <Reply item={item} />
            </div>
        ))}
        </div>
      </div>
    </div>
    <Pagination
      goToPage={goToPage}
      count={count}
      pageSize={criteria.limit}
      page={criteria.page}
      backgroundColor={backgroundColor}
    />
    {markAsResolved &&
    <span>
      <a href="#" onClick={e => markAsResolved(e)} className="res-st">{t('Or mark as resolved')}</a>
    </span>}
    <AddNew
      attach
      upload_name={upload_name}
      onSubmit={submitReply}
      label={t('Add Reply')}
      placeholder={t('Start typing')}
    />
  </React.Fragment>
);

Replies.propTypes = {
  t: PropTypes.func.isRequired,
  upload_name: PropTypes.string.isRequired,
};

export default Replies;



// WEBPACK FOOTER //
// ./src/components/comments/replies/Replies.jsx